export { LegalScreen } from './LegalDocument';
